import {
	Pipe,
	PipeTransform,
} from '@angular/core';

import { CommonGeneralSettingsService } from '../services/general_settings.service';
import { commonConstants } from '../constants/common.constants';

@Pipe({
	name: 'prettyNumber',
})
export class CommonPrettyNumberPipe implements PipeTransform {
	constructor (private generalSettings: CommonGeneralSettingsService) {}

	transform (digit: string | number, options: { fixAfterDecimal?: boolean } = {}) {
		if (!digit) {
			return digit;
		}

		options.fixAfterDecimal = options.fixAfterDecimal !== false;  // cut off to true by default is necessary numbers of signs after a comma
		const numberFormat = this.generalSettings.getGeneralSettings('NumberFormat') || {};
		const decimalSeparator = numberFormat.DecimalSeparator || commonConstants.defaultNumberDecimalSeparator;
		const groupSeparator = numberFormat.GroupSeparator || commonConstants.defaultNumberGroupSeparator;
		let result = digit.toString()
			.replace(/[' ]/g, '')
			.replace('.', decimalSeparator)
			.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);

		if (options.fixAfterDecimal) {
			const decimalIndex = result.indexOf(decimalSeparator);

			if (decimalIndex !== -1) {
				result = result.slice(0, decimalIndex + commonConstants.defaultNumberDigitsAfterDecimal + 1);
			}
		}

		return result;
	}
}
